<mat-sidenav-container class="sidenav-container">

  <mat-sidenav #drawer class="sidenav" fixedInViewport [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
    [mode]="(isHandset$ | async) ? 'over' : 'side'" [opened]="(isHandset$ | async) === false">

    <div *ngIf='_authService.isLoggedIn'>

      <mat-toolbar color="primary" style='background-color: rgb(2, 33, 80);'></mat-toolbar>

      <mat-nav-list *ngIf='_authService.isLoggedIn' (click)='toggle(drawer)'>


        <!-- PAINEL -->
        <div *ngIf='_authService.isAdmin'>
          <a mat-list-item href="#" routerLink="/dashboard">
            <div style="display: flex; flex-direction: row; align-items: center; ">
              <mat-icon>apps</mat-icon>
              <div>Painel</div>
            </div>
          </a>
        </div>

        <!-- CADASTROS -->
        <div *ngIf='_authService.isAdmin'>
          <a mat-list-item [matMenuTriggerFor]="menu_cad">
            <div style="display: flex; flex-direction: row; align-items: center; ">
              <mat-icon>person</mat-icon>
              <div>Cadastros</div>
            </div>
          </a>
          <hr>
          <mat-menu #menu_cad="matMenu" yPosition='above' xPosition='before'>

            <button mat-menu-item routerLink="/account">
              <mat-icon>supervisor_account</mat-icon><span>Admins</span>
            </button>

            <button mat-menu-item routerLink="/member">
              <mat-icon>people_outline</mat-icon><span>Usuários</span>
            </button>

            <button mat-menu-item [matMenuTriggerFor]="menu_gn1">
              <mat-icon>supervised_user_circle</mat-icon><span>GN1</span>
            </button>

            <mat-menu #menu_gn1="matMenu" yPosition='above' xPosition='before'>

              <button mat-menu-item routerLink="/member-gn1">
                <mat-icon>supervised_user_circle</mat-icon><span>Original</span>
              </button>

              <button mat-menu-item routerLink="/member-gn1-work">
                <mat-icon>supervised_user_circle</mat-icon><span>Work</span>
              </button>

            </mat-menu>


            <button mat-menu-item routerLink="/subcategory">
              <mat-icon>format_list_bulleted</mat-icon><span>Categorias</span>
            </button>

            <button mat-menu-item routerLink="/regional">
              <mat-icon>hub</mat-icon><span>Regionais</span>
            </button>

            <button mat-menu-item routerLink="/role">
              <mat-icon>assignment_ind_outlined</mat-icon><span>Papeis</span>
            </button>

            <button mat-menu-item routerLink="/tax">
              <mat-icon>local_atm</mat-icon><span>Taxas</span>
            </button>

            <button mat-menu-item routerLink="/config">
              <mat-icon>settings</mat-icon><span>Textos</span>
            </button>

            <button mat-menu-item routerLink="/department">
              <mat-icon>account_tree</mat-icon><span>Deptos</span>
            </button>

            <button mat-menu-item routerLink="/convention-center">
              <mat-icon>account_balance</mat-icon><span>Locais</span>
            </button>

            <button mat-menu-item routerLink="/country">
              <mat-icon>supervisor_account</mat-icon><span>Paises</span>
            </button>

          </mat-menu>

        </div>

        <!-- COMUNICAÇÃO -->
        <div *ngIf='_authService.isAdmin'>
          <a mat-list-item [matMenuTriggerFor]="menu_com">
            <div style="display: flex; flex-direction: row; align-items: center; ">
              <mat-icon>settings_remote</mat-icon>
              <div>Comunicação</div>
            </div>
          </a>
          <hr>
          <mat-menu #menu_com="matMenu" yPosition='below' xPosition='before'>

            <button mat-menu-item routerLink="/push">
              <mat-icon>settings_remote</mat-icon><span>Push</span>
            </button>

            <button mat-menu-item routerLink="/news">
              <mat-icon>post_add</mat-icon><span>Notícias</span>
            </button>

            <button mat-menu-item routerLink="/webnar">
              <mat-icon>live_tv</mat-icon><span>Webinars</span>
            </button>

          </mat-menu>
        </div>

        <!-- RELATÓRIOS-->
        <div *ngIf='_authService.isAdmin || _authService.isOperator'>

          <a mat-list-item [matMenuTriggerFor]="menu_report">
            <div style="display: flex; flex-direction: row; align-items: center; ">
              <mat-icon>print</mat-icon>
              <div>Relatórios</div>
            </div>
          </a>
          <hr>

          <mat-menu #menu_report="matMenu" yPosition='below' xPosition='before'>

            <button mat-menu-item routerLink="/reports">
              <mat-icon>print</mat-icon><span>Relatórios</span>
            </button>

            <button mat-menu-item routerLink="/reports-subscriptions">
              <mat-icon>list</mat-icon><span>Inscrições</span>
            </button>

            <button mat-menu-item routerLink="/document">
              <mat-icon>post_add</mat-icon><span>Documentos</span>
            </button>

            <button mat-menu-item routerLink="/reports-collect">
              <mat-icon>attach_money</mat-icon><span>Cobrança</span>
            </button>

            <button mat-menu-item routerLink="/reports-category">
              <mat-icon>format_list_bulleted</mat-icon><span>Categorias</span>
            </button>

            <button mat-menu-item routerLink="/site-logs">
              <mat-icon>format_list_bulleted</mat-icon><span>Site Logs</span>
            </button>

          </mat-menu>
        </div>

        <!-- CONGRESSO -->
        <div *ngIf='_authService.isAdmin || _authService.isOperator'>
          <a mat-list-item [matMenuTriggerFor]="menu_carta_congress">
            <div style="display: flex; flex-direction: row; align-items: center; ">
              <mat-icon>star</mat-icon>
              <div>Congressos</div>
            </div>
          </a>
          <hr>
          <mat-menu #menu_carta_congress="matMenu" yPosition='above' xPosition='before'>

            <div>
              <button mat-menu-item routerLink="/congress">
                <mat-icon>star</mat-icon><span>Congressos</span>
              </button>
            </div>

            <div *ngIf='_authService.isAdmin'>
              <button mat-menu-item routerLink="/congress-historic">
                <mat-icon>history</mat-icon><span>Histórico</span>
              </button>
            </div>

            <div>
              <button mat-menu-item [matMenuTriggerFor]="menu_archives">
                <mat-icon>preview</mat-icon><span>Arquivo</span>
              </button>
            </div>

          </mat-menu>

          <mat-menu #menu_archives="matMenu" yPosition='below' xPosition='before'>

            <a href="#" target="_blank" mat-menu-item routerLink="/50">
              <mat-icon>star</mat-icon><span>50º Congresso</span>
            </a>

            <a href="#" target="_blank" mat-menu-item routerLink="/49">
              <mat-icon>star</mat-icon><span>49º Congresso</span>
            </a>

          </mat-menu>

        </div>

        <!-- EVENTOS -->
        <div *ngIf='_authService.isAdmin'>
          <a mat-list-item [matMenuTriggerFor]="menu_carta">
            <div style="display: flex; flex-direction: row; align-items: center; ">
              <mat-icon>local_bar</mat-icon>
              <div>Eventos</div>
            </div>
          </a>
          <hr>
          <mat-menu #menu_carta="matMenu" yPosition='above' xPosition='before'>

            <button mat-menu-item routerLink="/event">
              <mat-icon>local_bar</mat-icon><span>Eventos</span>
            </button>

            <button mat-menu-item routerLink="/historic">
              <mat-icon>history</mat-icon><span>Histórico</span>
            </button>

          </mat-menu>
        </div>

        <!-- PRODUTOS -->
        <div *ngIf='_authService.isAdmin'>
          <a mat-list-item href="#" routerLink="/product">
            <div style="display: flex; flex-direction: row; align-items: center; ">
              <mat-icon>card_giftcard</mat-icon>
              <div>Produtos</div>
            </div>
          </a>
          <hr>
        </div>

        <!-- ANUIDADES -->
        <div *ngIf='_authService.isAdmin'>
          <a mat-list-item [matMenuTriggerFor]="menu_annuity">
            <div style="display: flex; flex-direction: row; align-items: center; ">
              <mat-icon>dashboard_customize</mat-icon>
              <div>Anuidades</div>
            </div>
          </a>
          <hr>
          <mat-menu #menu_annuity="matMenu" yPosition='above' xPosition='before'>

            <div *ngIf='_authService.isAdmin'>
              <button mat-menu-item routerLink="/annuity">
                <mat-icon>dashboard_customize</mat-icon><span>Anuidades</span>
              </button>
            </div>

            <div *ngIf='_authService.isAdmin'>
              <button mat-menu-item routerLink="/annuity-letter">
                <mat-icon>email_outline</mat-icon><span>Cartas</span>
              </button>
            </div>

          </mat-menu>

          <mat-menu #menu_archives="matMenu" yPosition='below' xPosition='before'>

            <a href="#" target="_blank" mat-menu-item routerLink="/50">
              <mat-icon>star</mat-icon><span>50º Congresso</span>
            </a>

            <a href="#" target="_blank" mat-menu-item routerLink="/49">
              <mat-icon>star</mat-icon><span>49º Congresso</span>
            </a>

          </mat-menu>

        </div>

        <!-- INSCRIÇÕES -->
        <div *ngIf='_authService.isAdmin'>

          <a mat-list-item [matMenuTriggerFor]="menu_inscr">
            <div style="display: flex; flex-direction: row; align-items: center; ">
              <mat-icon>mobile_friendly</mat-icon>
              <div>Inscrições</div>
            </div>
          </a>
          <hr>

          <mat-menu #menu_inscr="matMenu" yPosition='below' xPosition='before'>

            <button mat-menu-item routerLink="/ordered">
              <mat-icon>mobile_friendly</mat-icon><span>Inscrições</span>
            </button>

            <button mat-menu-item routerLink="/transfer">
              <mat-icon>multiple_stop</mat-icon><span>Transferências</span>
            </button>

            <button mat-menu-item routerLink="/refund">
              <mat-icon>mobile_off</mat-icon><span>Reembolsos</span>
            </button>

            <button mat-menu-item routerLink="/waiting">
              <mat-icon>hourglass_top</mat-icon><span>Lista Espera</span>
            </button>

          </mat-menu>
        </div>

        <!-- PATROCICIO -->
        <div *ngIf='_authService.isAdmin || _authService.isOperator'>
          <a mat-list-item [matMenuTriggerFor]="menu_sponsor">
            <div style="display: flex; flex-direction: row; align-items: center; ">
              <mat-icon>monetization_on</mat-icon>
              <div>Patrocínio</div>
            </div>
          </a>
          <hr>
          <mat-menu #menu_sponsor="matMenu" yPosition='above' xPosition='before'>

            <button mat-menu-item routerLink="/sponsor">
              <mat-icon>monetization_on</mat-icon><span>Patrocinadores</span>
            </button>
            <button mat-menu-item routerLink="/banner_sponsor">
              <mat-icon>wallpaper</mat-icon><span>Banners APP</span>
            </button>
            <button mat-menu-item routerLink="/push_sponsor">
              <mat-icon>settings_remote</mat-icon><span>Pushes</span>
            </button>
            <button mat-menu-item routerLink="/voucher">
              <mat-icon>local_atm</mat-icon><span>Vouchers</span>
            </button>
          </mat-menu>
        </div>


        <!-- BALCAO -->
        <div *ngIf='_authService.isUser || _authService.isOperator || _authService.isAdmin '>
          <a mat-list-item [matMenuTriggerFor]="menu_store">
            <div style="display: flex; flex-direction: row; align-items: center; ">
              <mat-icon>face</mat-icon>
              <div>Balcão</div>
            </div>
          </a>
          <hr>
          <mat-menu #menu_store="matMenu" yPosition='below' xPosition='before'>

            <button mat-menu-item routerLink="/front-desk">
              <!--*ngIf='_authService.isAdmin || _authService.isOperator'  -->
              <mat-icon>person_outline</mat-icon><span>Recepção</span>
            </button>
            <!--
            <button *ngIf=" _authService.isOperator" mat-menu-item routerLink="/caex">
              <mat-icon>person</mat-icon><span >CAEX</span>
            </button>
-->
            <button mat-menu-item routerLink="/agenda-member">
              <mat-icon>schedule</mat-icon><span>Atividades</span>
            </button>

            <!--
          <button mat-menu-item routerLink="/balcony"> 
            <mat-icon>local_grocery_store</mat-icon><span >Loja</span>
          </button>

          <button mat-menu-item routerLink="/badge">
            <mat-icon>portrait</mat-icon><span >Chachás</span>
          </button>
          -->

            <button mat-menu-item routerLink='/toten/""'>
              <mat-icon>monitor</mat-icon><span>Toten</span>
            </button>

            <button mat-menu-item routerLink='/toten-report'>
              <mat-icon>view_headline</mat-icon><span>Relatório</span>
            </button>

            <!--
          <button mat-menu-item routerLink="/companion">
            <mat-icon>supervisor_account</mat-icon><span >Acompanhante</span>
          </button>
          -->

          </mat-menu>
        </div>

        <!-- Site -->
        <div *ngIf='_authService.isAdmin'>
          <a mat-list-item [matMenuTriggerFor]="menu_site">
            <div style="display: flex; flex-direction: row; align-items: center; ">
              <mat-icon style="color: #0A61BD;">sunny</mat-icon>
              <div>sbccv.org.br</div>
            </div>
          </a>
          <hr>
          <mat-menu #menu_site="matMenu" yPosition='above' xPosition='before'>

            <!-- SBCCV SITE -->

            <!-- ÁREA CIENTíFICA -->

            <button mat-menu-item [matMenuTriggerFor]="menu_cientifica">
              <mat-icon style="color: #0A61BD;">format_list_bulleted</mat-icon><span>Área Científica</span>
            </button>

            <mat-menu #menu_cientifica="matMenu" yPosition='below' xPosition='before'>

              <!-- BOLETINS -->

              <button mat-menu-item routerLink="/bulletin">
                <mat-icon class="icon-dot" style="margin-right: 5px;">noise_control_off</mat-icon><span>Boletins</span>
              </button>

              <button mat-menu-item routerLink="/magazines">
                <mat-icon class="icon-dot" style="margin-right: 5px;">noise_control_off</mat-icon><span>Revistas</span>
              </button>

            </mat-menu>

            <!-- CARROSSEL -->

            <button mat-menu-item href="#" routerLink="/carousel">
              <mat-icon style="color: #0A61BD;">format_list_bulleted</mat-icon> <span>Carrossel</span>
            </button>

            <!-- CONGRESSOS E EVENTOS -->

            <button mat-menu-item [matMenuTriggerFor]="menu_orientacoes">
              <mat-icon style="color: #0A61BD;">format_list_bulleted</mat-icon><span>Congresos e Eventos</span>
            </button>

            <mat-menu #menu_orientacoes="matMenu" yPosition='above' xPosition='before'>

              <!--*
              <button mat-menu-item routerLink="/support">
                <mat-icon class="icon-dot" style="margin-right: 5px;">noise_control_off</mat-icon><span>Apoio a
                  Eventos</span>
              </button>
            -->

              <button mat-menu-item href="#" routerLink="/site-events-form">
                <mat-icon class="icon-dot" style="margin-right: 5px;">noise_control_off</mat-icon> <span>Apoio a
                  Eventos</span>
              </button>

              <button mat-menu-item href="#" routerLink="/congresso-atual">
                <mat-icon class="icon-dot"
                  style="margin-right: 5px;">noise_control_off</mat-icon><span>Congressos</span>
              </button>

              <button mat-menu-item href="#" routerLink="/congressos">
                <mat-icon class="icon-dot" style="margin-right: 5px;">noise_control_off</mat-icon><span>Congressos
                  Anteriores</span>
              </button>

              <button mat-menu-item href="#" routerLink="/site-events">
                <mat-icon class="icon-dot" style="margin-right: 5px;">noise_control_off</mat-icon> <span>Eventos</span>
              </button>

              <button mat-menu-item href="#" routerLink="/expositores">
                <mat-icon class="icon-dot" style="margin-right: 5px;">noise_control_off</mat-icon>
                <span>Expositores</span>
              </button>

            </mat-menu>

            <!-- Educação SBCCV -->

            <button mat-menu-item [matMenuTriggerFor]="menu_educacao">
              <mat-icon style="color: #0A61BD;">format_list_bulleted</mat-icon><span>Educação SBCCV</span>
            </button>

            <mat-menu #menu_educacao="matMenu" yPosition='above' xPosition='before'>


              <!-- Artigos Científicos -->

              <button mat-menu-item href="#" routerLink="/artigos-cientificos">
                <mat-icon class="icon-dot" style="margin-right: 5px;">noise_control_off</mat-icon>
                <span>Artigos Científicos</span>
              </button>

              <!-- Vimeo -->

              <button mat-menu-item href="#" routerLink="/vimeo">
                <mat-icon class="icon-dot" style="margin-right: 5px;">noise_control_off</mat-icon>
                <span>SBCCV Play</span>
              </button>


              <!-- Youtube -->

              <button mat-menu-item href="#" routerLink="/youtube">
                <mat-icon class="icon-dot" style="margin-right: 5px;">noise_control_off</mat-icon>
                <span>Youtube SBCCV</span>
              </button>

            </mat-menu>

            <!-- GALERIA -->

            <button mat-menu-item href="#" routerLink="/gallery">
              <mat-icon style="color: #0A61BD;">format_list_bulleted</mat-icon> <span>Galeria de Fotos</span>
            </button>


            <!-- Legislação e Publicação -->

            <button mat-menu-item [matMenuTriggerFor]="menu_regulation">
              <mat-icon style="color: #0A61BD;">format_list_bulleted</mat-icon><span>Legislação/Publicação</span>
            </button>

            <mat-menu #menu_regulation="matMenu" yPosition='above' xPosition='before'>

              <!-- DIRETRIZES -->

              <button mat-menu-item href="#" routerLink="/guidelines">
                <mat-icon class="icon-dot" style="margin-right: 5px;">noise_control_off</mat-icon>
                <span>Diretrizes</span>
              </button>

              <!-- PORTARIAS -->

              <button mat-menu-item href="#" routerLink="/regulations">
                <mat-icon class="icon-dot" style="margin-right: 5px;">noise_control_off</mat-icon>
                <span>Portarias</span>
              </button>

            </mat-menu>

            <!-- LINKS -->

            <button mat-menu-item routerLink="/links">
              <mat-icon style="color: #0A61BD;">format_list_bulleted</mat-icon><span>Links Importantes</span>
            </button>


            <!-- NOTICIAS -->

            <button mat-menu-item href="#" routerLink="/site-news">
              <mat-icon style="color: #0A61BD;">format_list_bulleted</mat-icon> <span>Notícias e Comunicados</span>
            </button>


            <!-- PROVAS -->

            <button mat-menu-item routerLink="/exams">
              <mat-icon style="color: #0A61BD;">format_list_bulleted</mat-icon><span>Provas</span>
            </button>

            <!-- RESIDENTS -->

            <button mat-menu-item routerLink="/residents">
              <mat-icon style="color: #0A61BD;">format_list_bulleted</mat-icon><span>Residentes</span>
            </button>

            <!-- SBCCV -->

            <button mat-menu-item [matMenuTriggerFor]="menu_quemsomos">
              <mat-icon style="color: #0A61BD;">format_list_bulleted</mat-icon><span>SBCCV</span>
            </button>

            <mat-menu #menu_quemsomos="matMenu" yPosition='above' xPosition='before'>

              <button mat-menu-item routerLink="/conduct">
                <mat-icon class="icon-dot" style="margin-right: 5px;">noise_control_off</mat-icon><span>Código de
                  Conduta</span>
              </button>

              <!-- DEPTOS -->

              <button mat-menu-item routerLink="/deptos">
                <mat-icon class="icon-dot"
                  style="margin-right: 5px;">noise_control_off</mat-icon><span>Departamentos</span>
              </button>

              <!-- DIRETORIA -->

              <button mat-menu-item routerLink="/directors">
                <mat-icon class="icon-dot" style="margin-right: 5px;">noise_control_off</mat-icon><span>Diretoria</span>
              </button>

              <!-- ESTATUTO -->

              <button mat-menu-item routerLink="/statute">
                <mat-icon class="icon-dot" style="margin-right: 5px;">noise_control_off</mat-icon><span>Estatuto</span>
              </button>

              <!-- HISTORIA -->

              <button mat-menu-item routerLink="/history">
                <mat-icon class="icon-dot" style="margin-right: 5px;">noise_control_off</mat-icon><span>História</span>
              </button>

              <!-- PDFs -->
              <button mat-menu-item href="#" routerLink="/pdfs">
                <mat-icon class="icon-dot" style="margin-right: 5px;">noise_control_off</mat-icon> <span>PDFs</span>
              </button>

              <!-- REGIONAIS -->

              <button mat-menu-item routerLink="/regionals">
                <mat-icon class="icon-dot" style="margin-right: 5px;">noise_control_off</mat-icon><span>Regionais</span>
              </button>

            </mat-menu>



            <!-- Seja Sócio -->

            <button mat-menu-item href="#" routerLink="/become-member">
              <mat-icon style="color: #0A61BD;">format_list_bulleted</mat-icon> <span>Seja Sócio</span>
            </button>

            <!-- TAVI  -->

            <button mat-menu-item [matMenuTriggerFor]="menu_tavi">
              <mat-icon style="color: #0A61BD;">format_list_bulleted</mat-icon><span>TAVI</span>
            </button>

            <mat-menu #menu_tavi="matMenu" yPosition='above' xPosition='before'>

              <button mat-menu-item routerLink="/tavi-centers">
                <mat-icon class="icon-dot" style="margin-right: 5px;">noise_control_off</mat-icon><span>Centros
                  Treinamento</span>
              </button>

              <button mat-menu-item routerLink="/tavi-docs">
                <mat-icon class="icon-dot" style="margin-right: 5px;">noise_control_off</mat-icon>
                <span>Documentos</span>
              </button>

              <button mat-menu-item routerLink="/tavi-profs">
                <mat-icon class="icon-dot" style="margin-right: 5px;">noise_control_off</mat-icon><span>Profis.
                  Credenciados</span>
              </button>



            </mat-menu>



          </mat-menu>

        </div>

      </mat-nav-list>

    </div>

  </mat-sidenav>

  <mat-sidenav-content class="sidenav-content" [ngClass]="{'bg-image':isHidden}">

    <mat-toolbar *ngIf="!hideToolBarTop" color="primary"
      style='background-color: rgb(2, 33, 80); border-right:solid 1px black; z-index: 9000;'>

      <button *ngIf="_authService.isLoggedIn" type="button" aria-label="Toggle sidenav" mat-icon-button
        (click)="drawer.toggle()">
        <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
      </button>

      <span>SBCCV</span>
      <!--
      <a mat-list-item href="#" style='color:white; text-decoration: none;' routerLink="/home">
        <span>SBCCV</span>
      </a>
      -->
      <div fxFlex fxLayout fxLayoutAlign="end">
        <div class='login-email' fxFlex fxLayout fxLayoutAlign="end" *ngIf="_authService.getLogged() as user">
          <a [matMenuTriggerFor]="userMenu">
            <span *ngIf="user.email"> {{user.email}} </span>
            <span *ngIf="user.phoneNumber"> {{user.phoneNumber}} </span>
          </a>
          <mat-menu #userMenu="matMenu">
            <!--
                    <button mat-menu-item routerLink="/profile">Perfil</button>
                    <button mat-menu-item routerLink="/password">Senha</button>
                  -->
            <button *ngIf="!user.phoneNumber" mat-menu-item (click)="showProfile()">Perfil</button>
            <button *ngIf="!user.phoneNumber" mat-menu-item (click)="showPassword()">Senha</button>
            <button mat-menu-item (click)="_authService.SignOut()">Sair</button>

          </mat-menu>
        </div>
      </div>

      <div class='fingerprint' overlapTrigger fxFlex fxLayout fxLayoutAlign="end" *ngIf="!_authService.getLogged()">
        <a mat-list-item href="#" routerLink="/sign-in">
          <mat-icon style='color:white;'>fingerprint</mat-icon>
        </a>
      </div>


    </mat-toolbar>

    <main>
      <router-outlet>
      </router-outlet>
    </main>
  </mat-sidenav-content>

</mat-sidenav-container>